import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';

import './styles.less';

const ContentHeading = (props) => {
    return (
        <div
            className={classNames(
                'p-content-heading',
                ({[`p-content-heading--${props.variant}`]: true}),
                ({[`p-content-heading--${props.alignment}`]: true}),
                ({'p-content-heading--icon': props.icon})
            )}
        >
            <h2
                className={classNames(
                    'p-content-heading__text',
                    ({[`p-content-heading__text--${props.variant}`]: true}),
                    ({[`p-content-heading__text--${props.alignment}`]: true})
                )}
            >
                {props.icon ? (
                    <span className="p-content-heading__icon">
                        <Icon icon={props.icon} />
                    </span>
                ) : null}
                {props.text}
            </h2>
        </div>
    );
};

ContentHeading.propTypes = {
    variant: PropTypes.oneOf(['Lined', 'lined', 'Themed', 'themed', 'None', 'none']).isRequired,
    alignment: PropTypes.oneOf(['Left', 'left', 'Center', 'center']),
    text: PropTypes.string.isRequired,
    icon: PropTypes.string
};

ContentHeading.defaultProps = {
    variant: 'lined',
    alignment: 'left',
    icon: undefined
};

export default ContentHeading;
